import { AppBar } from "../appbar/AppBar";

export const GuestLayout = ({ children }) => {
  return (
    <>
      <AppBar />
      {children}
    </>
  );
};
